// Layout
const websiteLayout = () => import('@/layouts/websiteLayout')

const termsCondition = () => import('./views/index')
// start Routes
export default [
  {
    path: '/terms-condition',
    name: 'termsCondition',
    component: websiteLayout,
    children: [{
      path: '',
      name: 'termsCondition',
      meta: {
        name: 'termsCondition',
        userType: '',
        permission: '',
        breadCrumb: [
          {
            text: 'endUser.termsCondition',
            active: true
          }
        ]
      },
      component: termsCondition
    }
    ]
  }
]
